/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CustomerReportCriteriaDto } from '../model/customerReportCriteriaDto';
import { CustomerReportPreviewResponseDto } from '../model/customerReportPreviewResponseDto';
import { SignatureReportDataDto } from '../model/signatureReportDataDto';
import { UploadPolicy } from '../model/uploadPolicy';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomerReportService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generatePreviewReport(body?: CustomerReportCriteriaDto, observe?: 'body', reportProgress?: boolean): Promise<CustomerReportPreviewResponseDto>;
    public generatePreviewReport(body?: CustomerReportCriteriaDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<CustomerReportPreviewResponseDto>>;
    public generatePreviewReport(body?: CustomerReportCriteriaDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<CustomerReportPreviewResponseDto>>;
    public generatePreviewReport(body?: CustomerReportCriteriaDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/customer-report/generate-preview`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPreviewReport(id: string, observe?: 'body', reportProgress?: boolean): Promise<CustomerReportPreviewResponseDto>;
    public getPreviewReport(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<CustomerReportPreviewResponseDto>>;
    public getPreviewReport(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<CustomerReportPreviewResponseDto>>;
    public getPreviewReport(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPreviewReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/customer-report/${encodeURIComponent(String(id))}/preview-pdf`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadSignatureReportDefaultData(id: string, observe?: 'body', reportProgress?: boolean): Promise<SignatureReportDataDto>;
    public getUploadSignatureReportDefaultData(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SignatureReportDataDto>>;
    public getUploadSignatureReportDefaultData(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SignatureReportDataDto>>;
    public getUploadSignatureReportDefaultData(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getUploadSignatureReportDefaultData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/customer-report/${encodeURIComponent(String(id))}/uploadData`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param previewId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadSignatureRequest(previewId: string, observe?: 'body', reportProgress?: boolean): Promise<UploadPolicy>;
    public getUploadSignatureRequest(previewId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<UploadPolicy>>;
    public getUploadSignatureRequest(previewId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<UploadPolicy>>;
    public getUploadSignatureRequest(previewId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (previewId === null || previewId === undefined) {
            throw new Error('Required parameter previewId was null or undefined when calling getUploadSignatureRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/customer-report/${encodeURIComponent(String(previewId))}/uploadSignature/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param previewId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isPreviewStillValid(previewId: string, observe?: 'body', reportProgress?: boolean): Promise<boolean>;
    public isPreviewStillValid(previewId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<boolean>>;
    public isPreviewStillValid(previewId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<boolean>>;
    public isPreviewStillValid(previewId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (previewId === null || previewId === undefined) {
            throw new Error('Required parameter previewId was null or undefined when calling isPreviewStillValid.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/customer-report/${encodeURIComponent(String(previewId))}/isStillValid`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public predictFromDate(body?: CustomerReportCriteriaDto, observe?: 'body', reportProgress?: boolean): Promise<Date>;
    public predictFromDate(body?: CustomerReportCriteriaDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Date>>;
    public predictFromDate(body?: CustomerReportCriteriaDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Date>>;
    public predictFromDate(body?: CustomerReportCriteriaDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/customer-report/from-date`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param previewId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendReport(previewId: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public sendReport(previewId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public sendReport(previewId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public sendReport(previewId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (previewId === null || previewId === undefined) {
            throw new Error('Required parameter previewId was null or undefined when calling sendReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/customer-report/${encodeURIComponent(String(previewId))}/send`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param previewId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public signReport(previewId: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public signReport(previewId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public signReport(previewId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public signReport(previewId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (previewId === null || previewId === undefined) {
            throw new Error('Required parameter previewId was null or undefined when calling signReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/customer-report/${encodeURIComponent(String(previewId))}/sign`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadReportData(body?: SignatureReportDataDto, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public uploadReportData(body?: SignatureReportDataDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public uploadReportData(body?: SignatureReportDataDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public uploadReportData(body?: SignatureReportDataDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/customer-report/uploadData`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
